export default function formatOrderStatus(type, orderStatus, orderPaymentMethod = 'general') {
  switch (type) {

    /**
     * paid: 判斷是不是已付款
     */
    case 'paid':
      const statusPaidMap = [
        false,  // cancel
        true,   // paid
        false,  // unpaid
        true,   // process
        true,   // complete
      ];

      return statusPaidMap[orderStatus];

    /**
     * alias: 格式化成alias
     */
    case 'alias':
      const statusAliasMap = [
        'cancel',
        'paid',
        'unpaid',
        'process',
        'complete',
      ];

      return statusAliasMap[orderStatus];

    /**
     * paid: 格式化成文字
     */
    case 'text':
      const orderType = orderPaymentMethod === 'prepaid' ? 'prepaid' : 'general';

      const statusTextMap = {
        'general': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.PAID' /* 已付款 */),
          this.$t('global.UNPAID' /* 未付款 */),
          this.$t('global.PROCESS' /* 待處理 */),
          this.$t('global.COMPLETE' /* 已完成 */)
        ],
        'prepaid': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.DEDUCTED' /* 已抵用 */),
          this.$t('global.CONFIRMED' /* 待確認 */),
        ]
      };

      return statusTextMap[orderType][orderStatus];

    default:
      return 'need type'
  }
}
